export default {
  title: 'Paga con Pix',
  hint: 'Copia il codice e incollalo in Pix nella tua app bancaria, oppure scansiona il codice QR con essa.',
  copy: 'Copia codice Pix',
  copied: 'Codice copiato',
  qr_alt: 'Codice QR Pix',
  expires_in: 'Il codice scade tra {{time}}',
  waiting: 'Confermeremo il tuo ordine non appena la tua banca invierà il pagamento.',
  open_page: 'Apri invece la pagina di pagamento',
  expired: 'Questo codice Pix è scaduto. Avvia di nuovo il pagamento per ottenerne uno nuovo.',
  cancel: 'Annulla pagamento',
  checking: 'Verifica del pagamento in corso…',
  close: 'Chiudi',
};
